import { withMediaQueryDesktop } from 'utils/mediaQueries/withMediaQueries';

import BopGalleryMiniatures from '../components/gallery/BopGalleryMiniatures';

export default withMediaQueryDesktop(BopGalleryMiniatures);
